import { s as spacing, m as marginPropTypes, p as paddingPropTypes, c as sizePropTypes } from './spacing-7e57ffb0.js';
import { b as classNames, c as classNamePropTypes } from './classNames-cc2dcbf1.js';
import { c as componentEl, d as defaults, p as props } from './componentEl-c8b73b10.js';
import { d as designTokens } from './_variables.es6-63d43442.js';
import 'prop-types';

/**
 * Here for backwards compatibility, so that add-ons don't break with this release
 */
const utils = {
  componentEl: {
    ...componentEl,
    /** @deprecated: use componentElDefaults */
    default: defaults,
    /** @deprecated: use componentElPropTypes */
    props: props
  },
  classNames: {
    ...classNames,
    /** @deprecated: use classNamePropTypes */
    classNameProps: classNamePropTypes
  },
  spacing: {
    ...spacing,
    /** @deprecated: use marginPropTypes */
    marginProps: marginPropTypes,
    /** @deprecated: use paddingPropTypes */
    paddingProps: paddingPropTypes,
    /** @deprecated: use sizePropTypes */
    sizeProps: sizePropTypes
  },
  designTokens
};

export { utils as default };
